import { Component, Vue } from 'vue-property-decorator';
import { NAME, CALENDAR_ROUTE } from './const';
import { Breadcrumbs } from './types';

@Component
export default class PageActivitiesCommon extends Vue {
  // Computed
  get breadcrumbs(): Breadcrumbs {
    return [
      {
        text: 'Главная',
        to: { path: '/' },
      },
      {
        text: NAME,
        to: { name: this.routeName },
      }
    ];
  }

  get routeName() {
    return CALENDAR_ROUTE;
  }
}



// WEBPACK FOOTER //
// ./src/pages/activities/common.ts